import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import { IQuestion } from '../../../../../base/components/Poll/components/Poll/types';
import { POLL_DELAY_AFTER } from '../../../../../base/components/Poll/components/constants';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../../middlewares/segment';
import { SegmentUserOption } from '../../../../../../../middlewares/segment/trackEntities/userEvents';
import { FEATURE_POLL_FIRST_VISIT_COOKIE_NAME, TEMPLATE_BOARD_ID_SESSIONSTORAGE } from '../constants';
import { ISegmentEventOption } from '../../../../../../../middlewares/segment/trackEntities/types';
import { root } from '../../../../../../../store/constants';
import {
    authUserPostTemplatePollAnswers
} from '../../../../../../../rest/effects/templatePollAnswers/authUserPostTemplatePollAnswers';
import { ITemplatePollAnswers } from '../../../../../../../rest/effects/templatePollAnswers/types';
import { getBoard } from '../../../../../../../store/model/selectors/getBoardById';

export const onSubmit = (
    results: IQuestion[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const templateBoardId = Number(sessionStorage.getItem(TEMPLATE_BOARD_ID_SESSIONSTORAGE));

        const templatePollAnswersRest: ITemplatePollAnswers = { 'stars': String(results[0].answer as number + 1), };

        const options: ISegmentEventOption[] = [
            {
                name: SegmentUserOption.RATING,
                value: results[0].answer as number + 1
            },
        ];
        if (results[1]) {
            options.push({
                name: SegmentUserOption.TEXT,
                value: results[1].answer as string
            });
            templatePollAnswersRest['review'] = results[1].answer as string;
        }
        dispatch(segmentTrackAction(SegmentUserEvent.TEMPLATE_POLL_RATED, {
            name: SegmentUserOption.FEATURE,
            value: templateBoardId,
        }, options));

        const templateBoard = getBoard(getState(), templateBoardId);
        dispatch(authUserPostTemplatePollAnswers(templateBoardId, templateBoard && templateBoard.name, templatePollAnswersRest));
        setTimeout(() => {
            sessionStorage.removeItem(TEMPLATE_BOARD_ID_SESSIONSTORAGE);
            root.App.Util.setCookie(FEATURE_POLL_FIRST_VISIT_COOKIE_NAME, true);
            root.App.controller.removeTemplatePoll();
        }, POLL_DELAY_AFTER); // только что ответил, показать Thank you
    };
    return action;
};
